import { Cloudinary } from '@cloudinary/base';
import store from '../store/index.js'

export default new Cloudinary({
    cloud: {
        cloudName: store.getters.cl_cloudname
    },
    url: {
        secure: true // force https, set to false to force http
    },
});


/** 
 * Below is how to use the JS SDK by public ID
 * (optional) : Scale the image by calling the resize scale library
*/
// import {scale} from "@cloudinary/base/actions/resize";
// const myImage = Cloudinary.image('DMS-Auto/Manufacturers/ACDelco.jpg');
// myImage.resize(scale().width(90));
// this.resource_img = myImage.toURL();